





















































import { Component, Prop, Vue } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

import CheckOn from "../resources/checkOn.vue";

@Component({
  components: {
      CheckOn
  }
})
export default class SelectContents extends Vue {
    @Prop() private snsType! : number;
    
    title = "ラベル反映内容";
    private contentsList = [
        { index : 0, isCheck : true, name : "アカウント名", key : "sns_account_name" },
        { index : 1, isCheck : true, name : "アカウントのアイコン", key : "sns_account_icon" },
        { index : 2, isCheck : true, name : "テキスト", key : "sns_account_text" },
        { index : 3, isCheck : true, name : "画像", key : "sns_account_image" },
        { index : 4, isCheck : true, name : "いいね数", key : "sns_account_favorite_count" },
        { index : 5, isCheck : true, name : "投稿日時", key : "sns_account_date_text" },
    ];
    public applyInfo = {};

    private cancel(){
        this.$emit("doCommand", "selectContentsCancel", null);
        this.$emit("close");
    }

    private decision(){
        for(var i = 0; i < this.contentsList.length; i++){
            this.applyInfo[this.contentsList[i].key] = this.contentsList[i].isCheck;
        }
        this.$emit("doCommand", "selectContents", this.applyInfo);
        this.$emit("close");
    }

    private get isCanClick(){
        var canClick = false;
        for(var i = 0; i < this.contentsList.length; i++){
            if(this.contentsList[i].isCheck){
                canClick = true;
                break;
            }
        }
        return canClick;
    }

    private get snsUserName(){
        var style = {};
        if(this.snsType == 1){
            style = {
                position: "absolute",
                height: "25px",
                left: "calc(10% + 35px)",
                top: "5%",
            };
        }
        else if(this.snsType == 2){
            style = {
                position: "absolute",
                height: "25px",
                left: "calc(10% + 35px)",
                top: "4%",
                fontSize : "12px",
            };
        }

        return style;
    }

    private get snsUserIcon(){
        var style = {
            position: "absolute",
            width: "25px",
            height: "25px",
            left: "10%",
            top: "5%",
        };
        return style;
    }

    private get snsTimelineText(){
        var style = {};
        if(this.snsType == 1){
            style = {
                position: "absolute",
                width: "70%",
                left: "20%",
                top: "18%",
                "word-wrap": "break-word",
            };
        }
        else if(this.snsType == 2){
            style = {
                position: "absolute",
                width: "80%",
                left: "10%",
                top: "18%",
                "word-wrap": "break-word",
            }
        }

        return style;
    }

    private get snsTimelineImage(){
        var style = {};
        if(this.snsType == 1){
            style = {
                position: "absolute",
                width: "70%",
                left: "20%",
                top: "47%",
            };
        }
        else if(this.snsType == 2){
            style = {
                position: "absolute",
                width: "80%",
                height: "30%",
                left: "10%",
                top: "47%",
            };
        }

        return style;
    }

    private get snsTimelineNice(){
        var style = {};
        if(this.snsType == 1){
            style = {
                position: "absolute",
                height: "25px",
                left: "20%",
                top: "82%",
            };
        }
        else if(this.snsType == 2){
            style = {
                position: "absolute",
                height: "25px",
                left: "10%",
                top: "82%",
            };
        }

        return style;
    }

    private get snsTimelineDateStyle(){
        var style = {};
        if(this.snsType == 1){
            style = {
                position : "absolute",
                right : "10%",
                top : "82%",
            };
        }
        else if(this.snsType == 2){
            style = {
                position : "absolute",
                left : "calc(10% + 35px)",
                top : "10%",
                fontSize : "10px",
            };
        }

        return style;
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
